import { ProcessorSwitch } from '../../atoms/processor-switch';
import { CardOnFileJustifi } from './card-on-file-justifi';
import { CardOnFileStripe } from './card-on-file-stripe';

export const CardOnFileSwitch = () => {
  return <ProcessorSwitch stripeContent={CardOnFileStripe} justifiContent={CardOnFileJustifi} />;
};
